import ColorThief from 'colorthief';
import chroma from 'chroma-js';

export async function getImageMetrics(url: string): Promise<{ width: number; height: number; color: string }> {
  const loadedImage = await new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
    img.src = url;
  });
  const colorData = await new ColorThief().getColor(loadedImage);
  return {
    width: loadedImage.naturalWidth,
    height: loadedImage.naturalHeight,
    color: chroma.rgb(colorData[0], colorData[1], colorData[2]).hex(),
  };
}